import { createBrowserHistory } from 'history';

import { userNavigationMenuRoutePath } from '@itm/shared-frontend/lib/utils';

export const history = createBrowserHistory();

export const RoutePath = {
  ...userNavigationMenuRoutePath,

  root: '/',
  permissionDenied: '/permission-denied',
  // Auth
  authRoot: '/auth',
  login: '/auth/login',
  logout: '/auth/logout',
  ssoCallback: '/auth/sso/callback',
  signUp: '/auth/signup/:verificationToken',
  setupMFA: '/auth/mfa/setup',
  resetMFA: '/auth/mfa/reset',
  changePasswordCompleted: '/auth/password/change/completed',
  resetPassword: '/auth/password/reset',
  resetPasswordCompleted: '/auth/password/reset/completed',
  termsOfUse: '/auth/agreements/terms-of-use',
  agreementsDataProtection: '/auth/agreements/data-protection',

  // Dashboard
  dashboard: '/dashboard',
  dashboardRequestDemoSuccess: '/dashboard/request-demo-success',

  //Data
  dataRoot: '/data',

  //Data Access
  dataAccessRoot: '/data/access',
  dataAccessMyAccessRoot: '/data/access/my-access',
  dataAccessMyAccessList: '/data/access/my-access/list',
  dataAccessMyAccessCreate: '/data/access/my-access/create',
  dataAccessMyAccessViewDetails: '/data/access/my-access/view/:dataAccessId/details',
  dataAccessManageRoot: '/data/access/manage',
  dataAccessManagePendingRequests: '/data/access/manage/company/:companyId/request-access',
  dataAccessManagePendingRequestsViewDetails:
    '/data/access/manage/company/:companyId/request-access/view/:dataAccessRequestId/details',
  dataAccessManageDataAccessDetails: '/data/access/manage/company/:companyId/data-access-details',
  dataAccessManageDataAccessDetailsViewDetails:
    '/data/access/manage/company/:companyId/data-access-details/view/:dataAccessId/details',

  // Data Retention
  dataRetentionRoot: '/data/retention',
  dataRetentionPolicyRoot: '/data/retention/company/:companyId/policy',
  dataRetentionPolicyList: '/data/retention/company/:companyId/policy/list',
  dataRetentionPolicyCreateRoot: '/data/retention/company/:companyId/policy/create',
  dataRetentionPolicyCreateDetails: '/data/retention/company/:companyId/policy/create/details',
  dataRetentionPolicyCreateRules: '/data/retention/company/:companyId/policy/create',
  dataRetentionPolicyViewRoot: '/data/retention/company/:companyId/policy/view/:policyId/version/:policyVersionId',
  dataRetentionPolicyViewDetails:
    '/data/retention/company/:companyId/policy/view/:policyId/version/:policyVersionId/details',
  dataRetentionPolicyViewRules:
    '/data/retention/company/:companyId/policy/view/:policyId/version/:policyVersionId/rules',
  dataRetentionPolicyViewVersions:
    '/data/retention/company/:companyId/policy/view/:policyId/version/:policyVersionId/versions',
  dataRetentionPolicyViewVersionsDetails:
    '/data/retention/company/:companyId/policy/view/:policyId/version/:policyVersionId/versions/:policyVersionHistoryId/details',
  dataRetentionPolicyEditRoot: '/data/retention/company/:companyId/policy/edit/:policyId/version/:policyVersionId',
  dataRetentionPolicyEditDetails:
    '/data/retention/company/:companyId/policy/edit/:policyId/version/:policyVersionId/details',
  dataRetentionPolicyEditRules:
    '/data/retention/company/:companyId/policy/edit/:policyId/version/:policyVersionId/rules',
  dataRetentionPolicyEditVersions:
    '/data/retention/company/:companyId/policy/edit/:policyId/version/:policyVersionId/versions',
  dataRetentionPolicyEditVersionsDetails:
    '/data/retention/company/:companyId/policy/edit/:policyId/version/:policyVersionId/versions/:policyVersionHistoryId/details',
  dataRetentionLogs: '/data/retention/company/:companyId/logs',

  // Notifications
  dataNotificationsRoot: '/data/notifications',
  dataNotificationsAllRoot: '/data/notifications/all',

  dataNotificationsAllDefaultRoot: '/data/notifications/all/default',
  dataNotificationsAllDefaultSummary: '/data/notifications/all/default/summary',
  dataNotificationsAllDefaultProductTemplateRoot: '/data/notifications/all/default/product/:productId/template',
  dataNotificationsAllDefaultProductTemplateList: '/data/notifications/all/default/product/:productId/template/list',
  dataNotificationsAllDefaultProductTemplateViewRoot:
    '/data/notifications/all/default/product/:productId/template/view/:templateId',
  dataNotificationsAllDefaultProductTemplateViewRecipients:
    '/data/notifications/all/default/product/:productId/template/view/:templateId/recipients',
  dataNotificationsAllDefaultProductTemplateViewEditor:
    '/data/notifications/all/default/product/:productId/template/view/:templateId/content',
  dataNotificationsAllDefaultProductTemplateViewAudit:
    '/data/notifications/all/default/product/:productId/template/view/:templateId/audit',
  dataNotificationsAllDefaultProductTemplateEditRoot:
    '/data/notifications/all/default/product/:productId/template/edit/:templateId',
  dataNotificationsAllDefaultProductTemplateEditRecipients:
    '/data/notifications/all/default/product/:productId/template/edit/:templateId/recipients',
  dataNotificationsAllDefaultProductTemplateEditEditor:
    '/data/notifications/all/default/product/:productId/template/edit/:templateId/content',
  dataNotificationsAllDefaultProductTemplateEditAudit:
    '/data/notifications/all/default/product/:productId/template/edit/:templateId/audit',

  dataNotificationsAllTenantRoot: '/data/notifications/all/tenant',
  dataNotificationsAllTenantSummary: '/data/notifications/all/tenant/:tenantId/summary',
  dataNotificationsAllTenantProductTemplateRoot: '/data/notifications/all/tenant/:tenantId/product/:productId/template',
  dataNotificationsAllTenantProductTemplateList:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/list',
  dataNotificationsAllTenantProductTemplateViewRoot:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/view/:templateId',
  dataNotificationsAllTenantProductTemplateViewRecipients:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/view/:templateId/recipients',
  dataNotificationsAllTenantProductTemplateViewEditor:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/view/:templateId/content',
  dataNotificationsAllTenantProductTemplateViewAudit:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/view/:templateId/audit',
  dataNotificationsAllTenantProductTemplateEditRoot:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/edit/:templateId',
  dataNotificationsAllTenantProductTemplateEditRecipients:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/edit/:templateId/recipients',
  dataNotificationsAllTenantProductTemplateEditEditor:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/edit/:templateId/content',
  dataNotificationsAllTenantProductTemplateEditAudit:
    '/data/notifications/all/tenant/:tenantId/product/:productId/template/edit/:templateId/audit',

  dataNotificationsAllCompanyRoot: '/data/notifications/all/company',
  dataNotificationsAllCompanySummary: '/data/notifications/all/company/:companyId/summary',
  dataNotificationsAllCompanyProductTemplateRoot:
    '/data/notifications/all/company/:companyId/product/:productId/template',
  dataNotificationsAllCompanyProductTemplateList:
    '/data/notifications/all/company/:companyId/product/:productId/template/list',
  dataNotificationsAllCompanyProductTemplateViewRoot:
    '/data/notifications/all/company/:companyId/product/:productId/template/view/:templateId',
  dataNotificationsAllCompanyProductTemplateViewRecipients:
    '/data/notifications/all/company/:companyId/product/:productId/template/view/:templateId/recipients',
  dataNotificationsAllCompanyProductTemplateViewEditor:
    '/data/notifications/all/company/:companyId/product/:productId/template/view/:templateId/content',
  dataNotificationsAllCompanyProductTemplateViewAudit:
    '/data/notifications/all/company/:companyId/product/:productId/template/view/:templateId/audit',
  dataNotificationsAllCompanyProductTemplateEditRoot:
    '/data/notifications/all/company/:companyId/product/:productId/template/edit/:templateId',
  dataNotificationsAllCompanyProductTemplateEditRecipients:
    '/data/notifications/all/company/:companyId/product/:productId/template/edit/:templateId/recipients',
  dataNotificationsAllCompanyProductTemplateEditEditor:
    '/data/notifications/all/company/:companyId/product/:productId/template/edit/:templateId/content',
  dataNotificationsAllCompanyProductTemplateEditAudit:
    '/data/notifications/all/company/:companyId/product/:productId/template/edit/:templateId/audit',

  dataNotificationsEmailLogsRoot: '/data/notifications/email-logs',
  dataNotificationsEmailLogsCompany: '/data/notifications/email-logs/company/:companyId',
  dataNotificationsEmailLogsAccount: '/data/notifications/email-logs/account',

  // Data Publish Configuration
  dataPublishRoot: '/data/publish',
  dataPublishConfiguration: '/data/publish/configuration',

  // Administration
  administrationRoot: '/administration',
  administrationConsole: '/administration/console',
  administrationProducts: '/administration/console/products',
  administrationGeneral: '/administration/console/general',
  administrationAudit: '/administration/console/audit',

  // Users
  administrationUserRoot: '/administration/user',
  administrationUserList: '/administration/user/list',
  administrationUserAuditRoot: '/administration/user/audit/company/:companyId',
  administrationUserAuditList: '/administration/user/audit/company/:companyId/list',
  administrationUserAuditDetails: '/administration/user/audit/company/:companyId/user/:userId/audit/:auditId/details',
  // Users Create
  administrationUserCreateRoot: '/administration/user/create',
  administrationUserCreatePersonalInformation: '/administration/user/create/personal-information',
  administrationUserCreatePermissions: '/administration/user/create/permissions',
  administrationUserCreateClientAccess: '/administration/user/create/client-access',
  administrationUserCreateEmployerAccess: '/administration/user/create/:userId/employer-access',
  // Users Update
  administrationUserUpdateRoot: '/administration/user/update/:userId',
  administrationUserUpdateUserDetail: '/administration/user/update/:userId/user-detail',
  administrationUserUpdateAuthHistory: '/administration/user/update/:userId/auth-history',
  administrationUserUpdateSFTP: '/administration/user/update/:userId/sftp',
  administrationUserUpdateAuditRoot: '/administration/user/update/:userId/audit',
  administrationUserUpdateAuditList: '/administration/user/update/:userId/audit/list',
  administrationUserUpdateAuditDetails: '/administration/user/update/:userId/audit/:auditId/details',
  administrationUserUpdateRolesAndPermissions: '/administration/user/update/:userId/roles-and-permissions',
  administrationUserUpdateRolesAndPermissionsCompanyList:
    '/administration/user/update/:userId/roles-and-permissions/company/list',
  administrationUserUpdateRolesAndPermissionsCompanyProductRoot:
    '/administration/user/update/:userId/roles-and-permissions/company/:companyId/product',
  administrationUserUpdateRolesAndPermissionsCompanyProductList:
    '/administration/user/update/:userId/roles-and-permissions/company/:companyId/product/list',
  administrationUserUpdateRolesAndPermissionsCompanyProductSchemeList:
    '/administration/user/update/:userId/roles-and-permissions/company/:companyId/product/:productId/scheme/list',
  administrationUserUpdateRolesAndPermissionsCompanyProductSchemeEmployerList:
    '/administration/user/update/:userId/roles-and-permissions/company/:companyId/product/:productId/scheme/:schemeId/employer/list',

  // Single sign-on (SSO)
  administrationSsoRoot: '/administration/sso',
  administrationSsoList: '/administration/sso/list',
  administrationSsoCreate: '/administration/sso/create',
  administrationSsoUpdate: '/administration/sso/update/:configurationId',

  // PGP Encryption
  administrationPgpEncryptionRoot: '/administration/pgp-encryption',
  administrationPgpEncryptionList: '/administration/pgp-encryption/list',
  // PGP Configuration Create
  administrationPgpEncryptionCreateRoot: '/administration/pgp-encryption/create',
  administrationPgpEncryptionCreateDetails: '/administration/pgp-encryption/create/details',
  administrationPgpEncryptionCreatePublicKey: '/administration/pgp-encryption/create/public-key',
  administrationPgpEncryptionCreateProducts: '/administration/pgp-encryption/create/:pgpKeyId/products',
  // PGP Configuration Update
  administrationPgpEncryptionUpdateRoot: '/administration/pgp-encryption/update/:pgpKeyId',
  administrationPgpEncryptionUpdateDetails: '/administration/pgp-encryption/update/:pgpKeyId/details',
  administrationPgpEncryptionUpdatePublicKey: '/administration/pgp-encryption/update/:pgpKeyId/public-key',
  administrationPgpEncryptionUpdateProducts: '/administration/pgp-encryption/update/:pgpKeyId/products',
  // PGP Configuration View
  administrationPgpEncryptionViewRoot: '/administration/pgp-encryption/view/:pgpKeyId',
  administrationPgpEncryptionViewDetails: '/administration/pgp-encryption/view/:pgpKeyId/details',
  administrationPgpEncryptionViewProducts: '/administration/pgp-encryption/view/:pgpKeyId/products',

  // Onboarding
  administrationOnboardingRoot: '/administration/onboarding',
  // Onboarding Company
  administrationOnboardingCompanyRoot: '/administration/onboarding/company',
  administrationOnboardingCompanyList: '/administration/onboarding/company/list',
  // Onboarding Company Create
  administrationOnboardingCompanyCreateRoot: '/administration/onboarding/company/create',
  administrationOnboardingCompanyCreateDetails: '/administration/onboarding/company/create/:companyId/details',
  administrationOnboardingCompanyCreateSchemes: '/administration/onboarding/company/create/:companyId/schemes',
  administrationOnboardingCompanyCreateProducts: '/administration/onboarding/company/create/:companyId/products',
  // Onboarding Company Update
  administrationOnboardingCompanyUpdateRoot: '/administration/onboarding/company/update/:companyId',
  administrationOnboardingCompanyUpdateDetails: '/administration/onboarding/company/update/:companyId/details',
  administrationOnboardingCompanyUpdateEmployersRoot: '/administration/onboarding/company/update/:companyId/employers',
  administrationOnboardingCompanyUpdateEmployersList:
    '/administration/onboarding/company/update/:companyId/employers/list',
  administrationOnboardingCompanyUpdateEmployersAdd:
    '/administration/onboarding/company/update/:companyId/employers/add',
  administrationOnboardingCompanyUpdateEmployersUpdate:
    '/administration/onboarding/company/update/:companyId/employers/:employerId/details',
  administrationOnboardingCompanyUpdateCreateScheme:
    '/administration/onboarding/company/update/:companyId/create-scheme',
  administrationOnboardingCompanyUpdateSchemeRoot: '/administration/onboarding/company/update/:companyId/scheme',
  administrationOnboardingCompanyUpdateSchemeList: '/administration/onboarding/company/update/:companyId/scheme/list',
  administrationOnboardingCompanyUpdateSchemeUpdateRoot:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId',
  administrationOnboardingCompanyUpdateSchemeUpdateDetails:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/details',
  administrationOnboardingCompanyUpdateSchemeUpdateSections:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/sections',
  administrationOnboardingCompanyUpdateSchemeUpdateSectionsUpdate:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/sections/update/:sectionId',
  administrationOnboardingCompanyUpdateSchemeUpdateSectionsCreate:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/sections/create',
  administrationOnboardingCompanyUpdateSchemeUpdateStrategicPartners:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/strategic-partners',
  administrationOnboardingCompanyUpdateSchemeUpdateStrategicPartnersUpdate:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/strategic-partners/update/:strategicPartnerId',
  administrationOnboardingCompanyUpdateSchemeUpdateStrategicPartnersCreate:
    '/administration/onboarding/company/update/:companyId/scheme/update/:schemeId/strategic-partners/create',
  administrationOnboardingCompanyUpdateProducts: '/administration/onboarding/company/update/:companyId/products',
  administrationOnboardingCompanyUpdateSchemeAccessRoot:
    '/administration/onboarding/company/update/:companyId/default-scheme-access',
  administrationOnboardingCompanyUpdateSchemeAccessMain:
    '/administration/onboarding/company/update/:companyId/default-scheme-access/main',
  administrationOnboardingCompanyUpdateSchemeAccessAudit:
    '/administration/onboarding/company/update/:companyId/default-scheme-access/audit',
  administrationOnboardingCompanyUpdateAuditRoot: '/administration/onboarding/company/update/:companyId/audit',
  administrationOnboardingCompanyUpdateAuditList: '/administration/onboarding/company/update/:companyId/audit/list',
  administrationOnboardingCompanyUpdateAuditDetails:
    '/administration/onboarding/company/update/:companyId/audit/:auditId/details',
  // Onboarding Company View
  administrationOnboardingCompanyViewRoot: '/administration/onboarding/company/view/:companyId',
  administrationOnboardingCompanyViewDetails: '/administration/onboarding/company/view/:companyId/details',
  administrationOnboardingCompanyViewEmployersRoot: '/administration/onboarding/company/view/:companyId/employers',
  administrationOnboardingCompanyViewEmployersList: '/administration/onboarding/company/view/:companyId/employers/list',
  administrationOnboardingCompanyViewEmployersAdd: '/administration/onboarding/company/view/:companyId/employers/add',
  administrationOnboardingCompanyViewEmployersView:
    '/administration/onboarding/company/view/:companyId/employers/:employerId/details',
  administrationOnboardingCompanyViewCreateScheme: '/administration/onboarding/company/view/:companyId/create-scheme',
  administrationOnboardingCompanyViewSchemeRoot: '/administration/onboarding/company/view/:companyId/scheme',
  administrationOnboardingCompanyViewSchemeList: '/administration/onboarding/company/view/:companyId/scheme/list',
  administrationOnboardingCompanyViewSchemeViewRoot:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId',
  administrationOnboardingCompanyViewSchemeViewDetails:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/details',
  administrationOnboardingCompanyViewSchemeViewSections:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/sections',
  administrationOnboardingCompanyViewSchemeViewSectionsView:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/sections/view/:sectionId',
  administrationOnboardingCompanyViewSchemeViewSectionsCreate:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/sections/create',
  administrationOnboardingCompanyViewSchemeViewStrategicPartners:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/strategic-partners',
  administrationOnboardingCompanyViewSchemeViewStrategicPartnersView:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/strategic-partners/view/:strategicPartnerId',
  administrationOnboardingCompanyViewSchemeViewStrategicPartnersCreate:
    '/administration/onboarding/company/view/:companyId/scheme/view/:schemeId/strategic-partners/create',
  administrationOnboardingCompanyViewProducts: '/administration/onboarding/company/view/:companyId/products',
  administrationOnboardingCompanyViewSchemeAccessRoot:
    '/administration/onboarding/company/view/:companyId/default-scheme-access',
  administrationOnboardingCompanyViewSchemeAccessMain:
    '/administration/onboarding/company/view/:companyId/default-scheme-access/main',
  administrationOnboardingCompanyViewSchemeAccessAudit:
    '/administration/onboarding/company/view/:companyId/default-scheme-access/audit',
  administrationOnboardingCompanyViewAuditRoot: '/administration/onboarding/company/view/:companyId/audit',
  administrationOnboardingCompanyViewAuditList: '/administration/onboarding/company/view/:companyId/audit/list',
  administrationOnboardingCompanyViewAuditDetails:
    '/administration/onboarding/company/view/:companyId/audit/:auditId/details',

  // Onboarding Bulk Uploads
  administrationOnboardingOnboardRoot: '/administration/onboarding/onboard',
  administrationOnboardingBulkUpload: '/administration/onboarding/onboard/company/:companyId/upload',
  administrationOnboardingBulkUploadHistory: '/administration/onboarding/onboard/company/:companyId/history',
  administrationOnboardingBulkUploadHistoryFile:
    '/administration/onboarding/onboard/company/:companyId/history/file/:fileId',
  // Onboarding Tenant
  administrationOnboardingTenantRoot: '/administration/onboarding/tenant',
  administrationOnboardingTenantList: '/administration/onboarding/tenant/list',
  administrationOnboardingTenantCreateRoot: '/administration/onboarding/tenant/create',
  administrationOnboardingTenantCreateDetails: '/administration/onboarding/tenant/create/:tenantId/details',
  administrationOnboardingTenantCreateBranding: '/administration/onboarding/tenant/create/:tenantId/branding',
  administrationOnboardingTenantCreateProducts: '/administration/onboarding/tenant/create/:tenantId/products',
  administrationOnboardingTenantUpdateRoot: '/administration/onboarding/tenant/update/:tenantId',
  administrationOnboardingTenantUpdateDetails: '/administration/onboarding/tenant/update/:tenantId/details',
  administrationOnboardingTenantUpdateBranding: '/administration/onboarding/tenant/update/:tenantId/branding',
  administrationOnboardingTenantUpdateProducts: '/administration/onboarding/tenant/update/:tenantId/products',
  // Products
  productUpdateRoot: '/administration/product/update/:productId',
  productUpdateCompany: '/administration/product/update/:productId/company',
  companyProductUpdateRoot: '/administration/company/:companyId/product/update/:productId',
  companyProductUpdateScheme: '/administration/company/:companyId/product/update/:productId/scheme',

  // API Integrations
  apiIntegrationsRoot: '/administration/api-integrations',
  apiIntegrationsList: '/administration/api-integrations/list',
  apiIntegrationsCreateRoot: '/administration/api-integrations/create',
  apiIntegrationsCreateCredentials: '/administration/api-integrations/create/:apiConnectionId/credentials',
  apiIntegrationsCreateProducts: '/administration/api-integrations/create/:apiConnectionId/products',

  // API Integrations Update and View
  apiIntegrationsUpdateRoot: '/administration/api-integrations/update/:apiConnectionId',
  apiIntegrationsUpdateCredentials: '/administration/api-integrations/update/:apiConnectionId/credentials',
  apiIntegrationsUpdateCredentialsIpAddress:
    '/administration/api-integrations/update/:apiConnectionId/credentials/ip-address',
  apiIntegrationsUpdateProducts: '/administration/api-integrations/update/:apiConnectionId/products',

  apiIntegrationsViewRoot: '/administration/api-integrations/view/:apiConnectionId/',
  apiIntegrationsViewCredentials: '/administration/api-integrations/view/:apiConnectionId/credentials',
  apiIntegrationsViewProducts: '/administration/api-integrations/view/:apiConnectionId/products',

  // API Integrations Third Party Integrations
  apiIntegrationsThirdPartyRoot: '/administration/api-integrations/third-party',
  apiIntegrationsThirdPartyList: '/administration/api-integrations/third-party/list',
  apiIntegrationsThirdPartyCreate: '/administration/api-integrations/third-party/create',
  apiIntegrationsThirdPartyViewDetails: '/administration/api-integrations/third-party/view/:integrationId/details',
  apiIntegrationsThirdPartyEditDetails: '/administration/api-integrations/third-party/edit/:integrationId/details',

  // Configuration Reports
  administrationReportsRoot: '/administration/reports',
  administrationReportsGenerate: '/administration/reports/company/:companyId/generate',
  administrationReportsHistoryRoot: '/administration/reports/company/:companyId/history',
  administrationReportsHistoryList: '/administration/reports/company/:companyId/history/list',
  administrationReportsHistoryDetails: '/administration/reports/company/:companyId/history/:reportId/details',
};

export { GuardedRoute } from './GuardedRoute';
export { routeAccess } from './routeAccess';
